/* eslint-disable max-lines */
import { Box, Grid, InputAdornment, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { FundingScreenStyles as classes } from './FundingScreenStyles';
import { CustomInput } from '../CustomInput/CustomInput';
import { CustomSelect } from '../CustomSelect/CustomSelect';
import { commonUtility, commonUtilityValueReturn } from '../UtilityFunctions';
import { dgiMapping } from '../../../services/dgiMapping';
import { dgiContMapping } from '../../../services/dgiContMapping';
import {
  ACCOUNT_NUM,
  ACCOUNT_NUMBER,
  ACCOUNT_TYPE,
  BANK,
  BANK_NAME,
  DEPOSIT_AMOUNT,
  DEPOSIT_MAX_AMOUNT_ERROR,
  DGI_CONT_ACC_NUM,
  ELITE_ACCOUNT_EN,
  ENTER_ACCOUNT_NUMBER,
  ENTER_ROUTING_NUMBER,
  ENTER_TRANSIT_NUMBER,
  INVALID_FORMAT_ERR,
  MANDATORY_FIELD_ERR,
  MAX_DEPOSIT_ERR,
  MINIMUM_DEPOSIT,
  MINIMUM_DEPOSIT_AMOUNT,
  MIN_DEPOSIT_ERR,
  OTHER,
  REQUIRED,
  ROUTING_NUMBER,
  TAX_YEAR,
  TRANSIT_NUMBER,
  TYPE_OF_ACCOUNT,
} from '../../../constants';
import {
  changeDgiAccNumberAndroid,
  isBundle,
  isCDIraproduct,
  isCDproduct,
  nbrToCurrencyFormat,
} from '../../commonCode';
import { productMapping } from '../../../services/productMapping';

/** AnotherBankAccount is the child component to FundingScreen
 */
const AnotherBankAccount = () => {
  const { t } = useTranslation();
  const [banks, setBanks] = useState([]);
  const [bankTransitNumbers, setBankTransitNumbers] = useState([]);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    fundData,
    fundDataErrors,
    setFundData,
    setFundDataErrors,
    setIsFundingScreenDirty,
    bankDetails,
    setIsEdeliveryScreenDirty,
    productName,
    cdFlowOffers,
    theme,
    productDataIRA,
    flowTypeETB,
  } = leadGenerationContext;

  const gridSizeForBundle = isBundle(productName) ? 12 : 6;
  /** set BankTransitNumbers array if available otherwise set empty array
   */
  useEffect(() => {
    if (fundData.transitNumber?.length >= 1 && fundData?.bank === OTHER) {
      if (/^0+$/.test(fundData.transitNumber) && fundData.transitNumber?.length === 9) {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    }
  }, [fundData.transitNumber]);
  const handleBlurRouting = (e) => {
    const numberString = e.target.value.toString();
    if (
      (e.target.value >= 1 || fundData?.transitNumber.length >= 1) &&
      fundData?.bank === OTHER &&
      fundData?.transitNumber !== OTHER
    ) {
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        transitNumber: numberString.padStart(9, '0'),
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          transitNumber: numberString,
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          transitNumber: numberString.padStart(9, '0'),
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else if (
      (e.target.value >= 1 || fundData?.customTransitNumber?.length >= 1) &&
      fundData?.transitNumber === OTHER
    ) {
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          customTransitNumber: numberString,
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          customTransitNumber: numberString.padStart(9, '0'),
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '',
        }));
      }
    }
  };
  const bankTransitNumbersCall = (bank) => {
    if (bank?.transistNumbers) {
      const transitNumbers = bank?.transistNumbers;
      if (!transitNumbers?.includes('Other') && bank?.transistNumbers.length > 0) {
        transitNumbers.push('Other');
      }
      if (transitNumbers && transitNumbers?.length > 0) {
        setBankTransitNumbers(transitNumbers);
      } else {
        setBankTransitNumbers([]);
      }
    } else {
      setBankTransitNumbers([]);
    }
  };
  useEffect(() => {
    const bankList = [];
    if (bankDetails && bankDetails?.length > 0) {
      for (const element of bankDetails) {
        bankList.push(element.bankName);
      }
    }
    setBanks(bankList);
    if (fundData?.bank) {
      if (bankDetails && bankDetails?.length > 0) {
        let bank = '';
        for (const element of bankDetails) {
          if (element.bankName === fundData?.bank) {
            bank = element;
            break;
          }
        }
        bankTransitNumbersCall(bank);
      }
    }

    if (cdFlowOffers?.depositAmount && isCDproduct(productName)) {
      setFundData({
        ...fundData,
        depositAmount: cdFlowOffers?.depositAmount,
        minDepositAmount: '1000',
      });
    } else if (
      (cdFlowOffers?.depositAmount || productDataIRA?.depositAmount) &&
      isCDIraproduct(productName)
    ) {
      setFundData({
        ...fundData,
        depositAmount: productDataIRA?.depositAmount
          ? productDataIRA?.depositAmount
          : cdFlowOffers?.depositAmount,
        minDepositAmount: '250',
      });
      setIsFundingScreenDirty(true);
    }
  }, []);
  /** Depoit amount handle change
   */
  const maxAmountCheck = (e) => {
    if (!dgiMapping(leadGenerationContext.productName)) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
    setFundDataErrors((prevState) => ({
      ...prevState,
      [e.target.name]: DEPOSIT_MAX_AMOUNT_ERROR,
    }));
    if (dgiMapping(leadGenerationContext.productName)) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const currentYear = new Date().getFullYear();
  const priorYear = currentYear - 1;
  const contributionLimit =
    fundData?.taxYear === String(currentYear)
      ? 7500
      : fundData?.taxYear === String(priorYear)
      ? 7000
      : 5000;

  const depositAmountCall = (e) => {
    if (e.target.value?.match(/^\d*$/) && e.target.value <= 1000000) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      if (
        dgiMapping(leadGenerationContext.productName) ||
        productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
        productMapping(leadGenerationContext.productName) === 'Libre' ||
        productMapping(leadGenerationContext.productName) === 'Ahorra'
      ) {
        if (
          parseInt(e.target.value, 10) >= parseInt(fundData?.minDepositAmount, 10) &&
          parseInt(e.target.value, 10) <= parseInt(contributionLimit, 10)
        ) {
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: '',
          }));
        } else if (parseInt(e.target.value, 10) > parseInt(contributionLimit, 10)) {
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]:
              productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
              productMapping(leadGenerationContext.productName) === 'Libre' ||
              productMapping(leadGenerationContext.productName) === 'Ahorra'
                ? t('The maximum limit for initial deposit is $5,000.', {
                    defaultValue: 'The maximum limit for initial deposit is $5,000.',
                  })
                : t('Contribution limit selected tax year message', {
                    contributionLimit: contributionLimit.toLocaleString(),
                    defaultValue: `The contribution limit for the selected tax year is $${contributionLimit.toLocaleString()}.`,
                  }),
          }));
        } else {
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]:
              productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
              productMapping(leadGenerationContext.productName) === 'Libre' ||
              productMapping(leadGenerationContext.productName) === 'Ahorra'
                ? t('A minimum deposit of $1,000 is required to open this account.', {
                    defaultValue: 'A minimum deposit of $1,000 is required to open this account.',
                  })
                : MIN_DEPOSIT_ERR,
          }));
        }
      } else if (parseInt(e.target.value, 10) >= parseInt(fundData?.minDepositAmount, 10)) {
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '',
        }));
      } else {
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: MIN_DEPOSIT_ERR,
        }));
      }
    } else if (e.target?.value > 1000000) {
      maxAmountCheck(e);
    } else if (e.target.value === '') {
      setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const typeOfAccountCall = (e) => {
    if (e.target.value.length > 0) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    } else {
      setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const accountNumberCall = (e) => {
    if (e.target?.value?.match(/^\d*$/)) {
      if (
        // leadGenerationContext.productName === 'Progresa Account' ||
        // leadGenerationContext.productName === 'Cuenta Progresa' ||
        leadGenerationContext.productName === 'Cuenta Ahorra' ||
        leadGenerationContext.productName === 'Ahorra Account'
      ) {
        if (e.target.value.length >= 9 && e.target.value.length <= 16) {
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: '',
          }));
          if (e.target.value.match(/^0*$/g)) {
            setFundData((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }));
            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '* Invalid Account Number',
            }));
          }
        } else {
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: INVALID_FORMAT_ERR,
          }));
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (e.target.value.length >= 9 && e.target.value.length <= 12) {
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: '',
          }));
          if (e.target.value.match(/^0*$/g)) {
            setFundData((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }));
            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '* Invalid Account Number',
            }));
          }
        } else {
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: INVALID_FORMAT_ERR,
          }));
        }
      }
    } else if (e.target.value === '') {
      setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const bankTransitNumbersChange = (bank) => {
    if (bank?.transistNumbers) {
      const transitNumbers = bank?.transistNumbers;
      if (!transitNumbers?.includes('Other')) {
        transitNumbers.push('Other');
      }
      if (transitNumbers && transitNumbers?.length > 0) {
        setBankTransitNumbers(transitNumbers);
        if (transitNumbers?.length === 1 && transitNumbers[0] !== OTHER) {
          setFundData((prevState) => ({
            ...prevState,
            transitNumber: transitNumbers[0],
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
        } else {
          setFundData((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
        }
      } else {
        setBankTransitNumbers([]);
        setFundData((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
        setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else {
      setBankTransitNumbers([]);
      setFundData((prevState) => ({ ...prevState, transitNumber: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        transitNumber: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const bankDetailsChange = (e) => {
    if (bankDetails && bankDetails?.length > 0) {
      let bank = '';
      for (const element of bankDetails) {
        if (element.bankName === e.target.value) {
          bank = element;
          break;
        }
      }
      bankTransitNumbersChange(bank);
    }
  };
  const transitNumberChange = (e) => {
    if (
      fundData?.bank === OTHER &&
      e.target.name === 'transitNumber' &&
      e.target.value.length >= 1 &&
      e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        transitNumber: e.target.value,
      }));

      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else if (
      fundData?.bank !== OTHER &&
      e.target.name === 'transitNumber' &&
      e.target.value.length >= 1

      // e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        transitNumber: e.target.value,
      }));
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        transitNumber: '',
      }));
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        customTransitNumber: '',
      }));
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        customTransitNumber: '',
      }));
    } else if (
      fundData?.transitNumber === OTHER &&
      e.target.name === 'customTransitNumber' &&
      e.target.value.length >= 1 &&
      e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        customTransitNumber: e.target.value,
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '',
        }));
      }
    } else if (e.target.value === '') {
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };
  /**
   * handle change for anotherbankAccount fields */
  const handleChange = (e) => {
    if (dgiMapping(leadGenerationContext.productName)) {
      setIsFundingScreenDirty(true);
      setIsEdeliveryScreenDirty(true);
    } else {
      setIsFundingScreenDirty(true);
    }
    switch (e.target.name) {
      case 'depositAmount':
        depositAmountCall(e);
        break;
      case 'typeOfAccount':
        typeOfAccountCall(e);
        break;
      case 'accountNumber':
        accountNumberCall(e);
        break;
      case 'bank':
        if (e.target.value.length > 0) {
          if (e.target.value !== OTHER) {
            setFundData((prevState) => ({
              ...prevState,
              otherBank: '',
            }));
            setFundDataErrors((prevState) => ({
              ...prevState,
              otherBank: '',
            }));
          }
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
            transitNumber: '',
            customTransitNumber: '',
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: '',
            transitNumber: '',
            customTransitNumber: '',
          }));
          bankDetailsChange(e);
        } else {
          setFundData((prevState) => ({
            ...prevState,
            transitNumber: '',
            customTransitNumber: '',
            [e.target.name]: e.target.value,
            customTransitNumber: '',
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            transitNumber: '',
            customTransitNumber: '',
            [e.target.name]: MANDATORY_FIELD_ERR,
            customTransitNumber: '',
          }));
          setBankTransitNumbers([]);
        }
        break;

      case 'otherBank':
        if (e.target.value) {
          const regex = /^[ a-zA-Z0-9.,&-]{1,30}$/;
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          if (e.target.value.match(regex)) {
            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '',
            }));
          } else {
            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '* Invalid format',
            }));
          }
        } else if (e.target.value === '') {
          setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: MANDATORY_FIELD_ERR,
          }));
        }
        break;

      case 'transitNumber':
        transitNumberChange(e);
        break;
      case 'customTransitNumber':
        transitNumberChange(e);
        break;
      case 'taxYear':
        taxYearChange(e);
        break;

      default:
        break;
    }
  };

  const handleBlur = (e) => {
    const currencyValue = e.target.value.replace(/^0+/, '');
    const newCurrencyValue = nbrToCurrencyFormat(currencyValue);
    setFundData((prevState) => ({
      ...prevState,
      [e.target.name]: newCurrencyValue,
    }));
  };

  const handleFocus = (e) => {
    const currencyValue = e.target.value.toString().replace(/[^\w\s]/gi, '');
    setFundData((prevState) => ({
      ...prevState,
      [e.target.name]: currencyValue,
    }));
  };
  const validateDepositAmount = (value, taxYearOverride) => {
    const taxYearToUse = taxYearOverride ?? fundData?.taxYear;
    const limit =
      String(taxYearToUse) === String(currentYear)
        ? 7500
        : String(taxYearToUse) === String(priorYear)
        ? 7000
        : 5000;
    if (!value?.toString()?.match(/^\d*$/) || value === '') {
      if (value === '') {
        setFundDataErrors((prev) => ({ ...prev, depositAmount: MANDATORY_FIELD_ERR }));
      }
      return;
    }

    const intValue = parseInt(value, 10);
    if (
      dgiMapping(leadGenerationContext.productName) ||
      productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
      productMapping(leadGenerationContext.productName) === 'Libre' ||
      productMapping(leadGenerationContext.productName) === 'Ahorra'
    ) {
      if (intValue >= parseInt(fundData?.minDepositAmount, 10) && intValue <= parseInt(limit, 10)) {
        setFundDataErrors((prev) => ({ ...prev, depositAmount: '' }));
      } else if (intValue > parseInt(limit, 10)) {
        setFundDataErrors((prev) => ({
          ...prev,
          depositAmount:
            productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
            productMapping(leadGenerationContext.productName) === 'Libre' ||
            productMapping(leadGenerationContext.productName) === 'Ahorra'
              ? t('The maximum limit for initial deposit is $5,000.', {
                  defaultValue: 'The maximum limit for initial deposit is $5,000.',
                })
              : t('Contribution limit selected tax year message', {
                  contributionLimit: limit.toLocaleString(),
                  defaultValue: `The contribution limit for the selected tax year is $${limit.toLocaleString()}.`,
                }),
        }));
      } else {
        setFundDataErrors((prev) => ({
          ...prev,
          depositAmount:
            productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
            productMapping(leadGenerationContext.productName) === 'Libre' ||
            productMapping(leadGenerationContext.productName) === 'Ahorra'
              ? t('A minimum deposit of $1,000 is required to open this account.', {
                  defaultValue: 'A minimum deposit of $1,000 is required to open this account.',
                })
              : MIN_DEPOSIT_ERR,
        }));
      }
    } else if (intValue >= parseInt(fundData?.minDepositAmount, 10)) {
      setFundDataErrors((prev) => ({ ...prev, depositAmount: '' }));
    } else {
      setFundDataErrors((prev) => ({ ...prev, depositAmount: MIN_DEPOSIT_ERR }));
    }
  };

  const taxYearChange = (e) => {
    if (e.target.value.length > 0) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
      if (fundData?.depositAmount) {
        const numericDeposit = fundData.depositAmount.toString().replace(/[^\d]/g, '');
        validateDepositAmount(numericDeposit, e.target.value);
      }
    } else if (dgiMapping(leadGenerationContext.productName)) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: '',
        depositAmount: '',
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
        depositAmount: fundData.depositAmount ? '' : MANDATORY_FIELD_ERR,
      }));
    } else {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: '',
        depositAmount: '',
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
        depositAmount: '',
      }));
    }
  };
  /**
   *  handle change for DGI Account number related to DGI contribution product */
  const handleChangeDgiAccAndroid = (e) => {
    changeDgiAccNumberAndroid(e, leadGenerationContext);
  };
  const getTaxYearOptions = () => [String(currentYear), String(priorYear)];

  return (
    <>
      {dgiMapping(leadGenerationContext.productName) && (
        <Grid
          container
          size={{ md: 12, sm: 12, xs: 12 }}
          sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <CustomSelect
              isBundle={isBundle(productName)}
              id="taxYear"
              dataTestId="taxYear_id"
              required={!isBundle(productName)}
              inputLabelAriaLabel={`${t(TAX_YEAR, {
                defaultValue: TAX_YEAR,
              })} `}
              label={t(TAX_YEAR, { defaultValue: TAX_YEAR })}
              options={getTaxYearOptions()}
              nsSeparator="|"
              handleChange={handleChange}
              fullWidth
              value={commonUtility(fundData?.taxYear)}
              error={fundDataErrors?.taxYear}
              selectAriaLabel={`${t('Aria Label Tax Year', {
                defaultValue: 'Tax Year Required Select Tax Year dropdown menu button',
              })}`}
            />

            <Box component="span" role="alert" sx={classes.error_message}>
              {t(fundDataErrors?.taxYear, {
                defaultValue: fundDataErrors?.taxYear,
              })}
            </Box>
          </Grid>
        </Grid>
      )}
      {!dgiMapping(leadGenerationContext.productName) && (
        <Grid
          container
          size={{ md: 12 }}
          style={{ marginTop: '13px' }}
          sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <CustomInput
              isBundle={isBundle(productName)}
              id="depositAmount"
              dataTestId="depositAmount_id"
              startAdornment={
                <InputAdornment position="start">
                  <Typography component="p" color={theme?.palette?.primary?.main}>
                    $
                  </Typography>
                </InputAdornment>
              }
              required={!isBundle(productName)}
              autoFocus
              inputLabelAriaLabel={`${t(DEPOSIT_AMOUNT, {
                defaultValue: DEPOSIT_AMOUNT,
              })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
              label={
                <span
                  style={{
                    color:
                      isBundle(productName) && fundDataErrors?.depositAmount ? 'red' : 'inherit',
                  }}
                >
                  {t(isBundle(productName) ? 'DEPOSIT_AMOUNT_BUNDLE' : DEPOSIT_AMOUNT)}
                </span>
              }
              handleChange={handleChange}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              disabled={
                fundData?.depositAmount && (isCDproduct(productName) || isCDIraproduct(productName))
              }
              placeholder={`${t(MINIMUM_DEPOSIT, {
                defaultValue: MINIMUM_DEPOSIT,
              })}: $${fundData?.minDepositAmount}`}
              fullWidth
              inputProps={{
                'data-testid': 'deposit-amount',
                maxLength: 7,
                inputMode: 'numeric',
              }}
              value={commonUtilityValueReturn(fundData?.depositAmount, fundData?.depositAmount, '')}
              error={commonUtility(fundDataErrors?.depositAmount)}
            />
            <Box
              component="span"
              sx={classes.error_message}
              role="alert"
              data-testid="deposit-amount-error"
            >
              {fundDataErrors?.depositAmount === MIN_DEPOSIT_ERR && fundData.minDepositAmount
                ? `${t(fundDataErrors?.depositAmount, {
                    defaultValue: fundDataErrors?.depositAmount,
                  })}${fundData?.minDepositAmount}`
                : t(fundDataErrors?.depositAmount, {
                    defaultValue: fundDataErrors?.depositAmount,
                  })}
            </Box>
          </Grid>
        </Grid>
      )}
      <Grid
        container
        size={{ md: 12 }}
        sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
      >
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <CustomSelect
            isBundle={isBundle(productName)}
            id="typeOfAccount"
            dataTestId="typeOfAccount_id"
            required={!isBundle(productName)}
            inputLabelAriaLabel={`${t(isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT, {
              defaultValue: isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT,
            })}`}
            label={
              <span
                style={{
                  color: isBundle(productName) && fundDataErrors?.typeOfAccount ? 'red' : 'inherit',
                }}
              >
                {t(isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT, {
                  defaultValue: isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT,
                })}
              </span>
            }
            options={['Checking', 'Savings']}
            nsSeparator="|"
            handleChange={handleChange}
            fullWidth
            value={fundData?.typeOfAccount ? fundData?.typeOfAccount : ''}
            error={fundDataErrors?.typeOfAccount}
            selectAriaLabel={`${t('Aria Label Type Of Account', {
              defaultValue: 'Type Of Account Required Select Type Of Account dropdown menu button',
            })}`}
          />
          <Box component="span" role="alert" sx={classes.error_message}>
            {t(fundDataErrors?.typeOfAccount, {
              defaultValue: fundDataErrors?.typeOfAccount,
            })}
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        size={{ md: 12, sm: 12, xs: 12 }}
        sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
      >
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <CustomInput
            isBundle={isBundle(productName)}
            id="accountNumber"
            dataTestId="accountNumber_id"
            required={!isBundle(productName)}
            inputLabelAriaLabel={`${t(isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER, {
              defaultValue: isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={
              <span
                style={{
                  color: isBundle(productName) && fundDataErrors?.accountNumber ? 'red' : 'inherit',
                }}
              >
                {t(isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER, {
                  defaultValue: isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER,
                })}
              </span>
            }
            handleChange={handleChange}
            placeholder={t(ENTER_ACCOUNT_NUMBER, {
              defaultValue: ENTER_ACCOUNT_NUMBER,
            })}
            fullWidth
            inputProps={
              // leadGenerationContext.productName === 'Progresa Account' ||
              // leadGenerationContext.productName === 'Cuenta Progresa' ||
              leadGenerationContext.productName === 'Cuenta Ahorra' ||
              leadGenerationContext.productName === 'Ahorra Account'
                ? {
                    maxLength: 16,
                    'data-testid': 'account-number',
                    inputMode: 'numeric',
                  }
                : {
                    maxLength: 12,
                    'data-testid': 'account-number',
                    inputMode: 'numeric',
                  }
            }
            value={fundData?.accountNumber ? fundData.accountNumber : ''}
            error={fundDataErrors?.accountNumber ? fundDataErrors.accountNumber : ''}
          />
          <Box
            component="span"
            sx={classes.error_message}
            role="alert"
            data-testid="account-number-error"
          >
            {t(fundDataErrors?.accountNumber, {
              defaultValue: fundDataErrors?.accountNumber,
            })}
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        size={{ md: 12, sm: 12, xs: 12 }}
        sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
      >
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <CustomSelect
            isBundle={isBundle(productName)}
            id="bank"
            dataTestId="bank_id"
            required={!isBundle(productName)}
            inputLabelAriaLabel={`${t(BANK, { defaultValue: BANK })} `}
            label={t(BANK, { defaultValue: BANK })}
            options={banks}
            nsSeparator="|"
            handleChange={handleChange}
            fullWidth
            value={commonUtility(fundData?.bank)}
            error={fundDataErrors?.bank}
            selectAriaLabel={`${t('Aria Label Bank', {
              defaultValue: 'Bank Required Select Bank dropdown menu button',
            })}`}
          />
          <Box component="span" role="alert" sx={classes.error_message}>
            {t(fundDataErrors?.bank, {
              defaultValue: fundDataErrors?.bank,
            })}
          </Box>
        </Grid>
      </Grid>
      {fundData?.bank === OTHER ? (
        <Grid
          container
          size={{ md: 12, sm: 12, xs: 12 }}
          sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <CustomInput
              isBundle={isBundle(productName)}
              id="otherBank"
              dataTestId="otherBank_id"
              required={!isBundle(productName)}
              inputLabelAriaLabel={`${t(BANK_NAME, { defaultValue: BANK_NAME })} ${t(REQUIRED, {
                defaultValue: REQUIRED,
              })}`}
              label={t(BANK_NAME, { defaultValue: BANK_NAME })}
              handleChange={handleChange}
              placeholder={t('Enter Bank name', {
                defaultValue: 'Enter Bank name',
              })}
              fullWidth
              inputProps={{ 'data-testid': 'Other_bank', maxLength: 30 }}
              value={commonUtility(fundData?.otherBank)}
              error={commonUtility(fundDataErrors?.otherBank)}
            />
            <Box
              component="span"
              sx={classes.error_message}
              role="alert"
              data-testid="otherBank-error"
            >
              {t(fundDataErrors?.otherBank, {
                defaultValue: fundDataErrors?.otherBank,
              })}
            </Box>
          </Grid>
        </Grid>
      ) : (
        ''
      )}
      <Grid
        container
        size={{ md: 12, sm: 12, xs: 12 }}
        sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
      >
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          {bankTransitNumbers && bankTransitNumbers.length > 1 ? (
            <CustomSelect
              isBundle={isBundle(productName)}
              id="transitNumber"
              dataTestId="transitNumber_id"
              required={!isBundle(productName)}
              inputLabelAriaLabel={`${t(isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER, {
                defaultValue: isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER,
              })}`}
              label={
                <span
                  style={{
                    color:
                      isBundle(productName) && fundDataErrors?.transitNumber ? 'red' : 'inherit',
                  }}
                >
                  {t(isBundle(productName) ? 'ROUTING_BUNDLE' : TRANSIT_NUMBER)}
                </span>
              }
              handleChange={handleChange}
              options={bankTransitNumbers}
              nsSeparator="|"
              fullWidth
              value={commonUtility(fundData?.transitNumber)}
              error={fundDataErrors?.transitNumber}
              selectAriaLabel={`${t('Aria Label Transit', {
                defaultValue: 'Transit Number Required Select Transit Number dropdown menu button',
              })}`}
            />
          ) : (
            <CustomInput
              id="transitNumber"
              isBundle={isBundle(productName)}
              // disabled={
              //   bankTransitNumbers &&
              //   bankTransitNumbers.length === 1 &&
              //   productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN
              // }
              dataTestId="transitNumber_id"
              required={!isBundle(productName)}
              inputLabelAriaLabel={`${t(isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER, {
                defaultValue: isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER,
              })}`}
              label={
                <span
                  style={{
                    color:
                      isBundle(productName) && fundDataErrors?.transitNumber ? 'red' : 'inherit',
                  }}
                >
                  {t(isBundle(productName) ? 'ROUTING_BUNDLE' : TRANSIT_NUMBER)}
                </span>
              }
              handleChange={handleChange}
              handleBlur={handleBlurRouting}
              placeholder={t(
                isBundle(productName) ? ENTER_ROUTING_NUMBER : 'Enter Route & Transit Number',
                {
                  defaultValue: isBundle(productName)
                    ? ENTER_ROUTING_NUMBER
                    : 'Enter Route & Transit Number',
                }
              )}
              fullWidth
              inputProps={{
                maxLength: fundData?.bank === OTHER ? 9 : 25,
                'data-testid': 'route-and-transit-number',
                inputMode: 'numeric',
              }}
              value={commonUtility(fundData?.transitNumber)}
              error={commonUtility(fundDataErrors?.transitNumber)}
            />
          )}
          <Box
            component="span"
            sx={classes.error_message}
            role="alert"
            data-testid="route-and-transit-number-error"
          >
            {t(fundDataErrors?.transitNumber, {
              defaultValue: fundDataErrors?.transitNumber,
            })}
          </Box>
        </Grid>
      </Grid>
      {fundData?.transitNumber === 'Other' && (
        <Grid
          container
          size={{ md: 12, sm: 12, xs: 12 }}
          sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <CustomInput
              isBundle={isBundle(productName)}
              id="customTransitNumber"
              // disabled={
              //   bankTransitNumbers &&
              //   bankTransitNumbers.length === 1 &&
              //   isPlaidProduct(leadGenerationContext.productName)
              // }
              dataTestId="custom_transitNumber_id"
              required={!isBundle(productName)}
              inputLabelAriaLabel={`${t(ENTER_TRANSIT_NUMBER, {
                defaultValue: ENTER_TRANSIT_NUMBER,
              })}${t(REQUIRED, {
                defaultValue: REQUIRED,
              })}`}
              label={t(ENTER_TRANSIT_NUMBER, { defaultValue: ENTER_TRANSIT_NUMBER })}
              handleChange={handleChange}
              handleBlur={handleBlurRouting}
              placeholder={t('Enter Route & Transit Number', {
                defaultValue: 'Enter Route & Transit Number',
              })}
              fullWidth
              inputProps={{
                maxLength: fundData?.transitNumber === OTHER ? 9 : 25,
                'data-testid': 'route-and-transit-number',
                inputMode: 'numeric',
              }}
              value={commonUtility(fundData?.customTransitNumber)}
              error={commonUtility(fundDataErrors?.customTransitNumber)}
            />
            <Box
              component="span"
              sx={classes.error_message}
              role="alert"
              data-testid="route-and-transit-number-error"
            >
              {t(fundDataErrors?.customTransitNumber, {
                defaultValue: fundDataErrors?.customTransitNumber,
              })}
            </Box>
          </Grid>
        </Grid>
      )}
      {dgiMapping(leadGenerationContext.productName) && (
        <Grid
          container
          size={{ md: 12 }}
          style={{ marginTop: '13px' }}
          sx={[classes.inputs_grid_margin_another, classes.field_padding_right]}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <CustomInput
              isBundle={isBundle(productName)}
              id="depositAmount"
              dataTestId="depositAmount_id"
              startAdornment={
                <InputAdornment position="start">
                  <Typography component="p" color={theme?.palette?.primary?.main}>
                    $
                  </Typography>
                </InputAdornment>
              }
              required={!isBundle(productName)}
              autoFocus
              inputLabelAriaLabel={`${t(DEPOSIT_AMOUNT, {
                defaultValue: DEPOSIT_AMOUNT,
              })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
              label={
                <span
                  style={{
                    color:
                      isBundle(productName) && fundDataErrors?.depositAmount ? 'red' : 'inherit',
                  }}
                >
                  {t(isBundle(productName) ? 'DEPOSIT_AMOUNT_BUNDLE' : DEPOSIT_AMOUNT)}
                </span>
              }
              handleChange={handleChange}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              disabled={!fundData?.taxYear}
              placeholder={`${t(MINIMUM_DEPOSIT, {
                defaultValue: MINIMUM_DEPOSIT,
              })}: $${fundData?.minDepositAmount}`}
              fullWidth
              inputProps={{
                'data-testid': 'deposit-amount',
                maxLength: 7,
                inputMode: 'numeric',
              }}
              value={commonUtilityValueReturn(fundData?.depositAmount, fundData?.depositAmount, '')}
              error={commonUtility(fundDataErrors?.depositAmount)}
            />
            <Box
              component="span"
              sx={classes.error_message}
              role="alert"
              data-testid="deposit-amount-error"
            >
              {fundDataErrors?.depositAmount === MIN_DEPOSIT_ERR && fundData.minDepositAmount
                ? `${t(fundDataErrors?.depositAmount, {
                    defaultValue: fundDataErrors?.depositAmount,
                  })}${fundData?.minDepositAmount}`
                : t(fundDataErrors?.depositAmount, {
                    defaultValue: fundDataErrors?.depositAmount,
                  })}
            </Box>
          </Grid>
        </Grid>
      )}
      {dgiContMapping(leadGenerationContext.productName) && (
        <Grid
          container
          size={{ md: 12, sm: 12, xs: 12 }}
          sx={[classes.inputs_grid_margin_another, classes.field_padding_oriental_DGI]}
        >
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <>
              <CustomInput
                isBundle={isBundle(productName)}
                id="dgiAccountNumber"
                dataTestId="dgiAccountno_id"
                inputLabelAriaLabel={`${t(DGI_CONT_ACC_NUM, {
                  defaultValue: DGI_CONT_ACC_NUM,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(DGI_CONT_ACC_NUM, { defaultValue: DGI_CONT_ACC_NUM })}
                required={!isBundle(productName)}
                handleChange={handleChangeDgiAccAndroid}
                placeholder="NEE/NEC-XXXXXX"
                fullWidth
                inputProps={{ maxLength: 11 }}
                value={commonUtility(fundData?.dgiAccountNumber)}
                error={commonUtility(fundDataErrors?.dgiAccountNumber)}
              />
              <Box
                component="span"
                sx={classes.error_message}
                role="alert"
                data-testid="account-number-error"
              >
                {t(fundDataErrors?.dgiAccountNumber, {
                  defaultValue: fundDataErrors?.dgiAccountNumber,
                })}
              </Box>
            </>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AnotherBankAccount;
